(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/jackpots.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/jackpots.js');

'use strict';

svs.numbergames.results.models.Jackpot = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    defaultJackpot: false,
    jackpotAmountString: '',
    jackpotAmount: undefined,
    lotto1: {},
    lotto2: {},
    dromvinst: {}
  },
  initialize() {
    svs.numbergames.results.jackpotsRadio.reply('jackpotInfo', attributeKey => this.get(attributeKey));
  },
  parse(attrs) {
    if (Array.isArray(attrs) && svs.numbergames.productMapping.isLotto(attrs[0].productId)) {
      const [lotto1, lotto2, dromvinst] = attrs;
      return {
        lotto1,
        lotto2,
        dromvinst
      };
    }
    return {
      defaultJackpot: attrs.defaultJackpot,
      jackpotAmountString: attrs.jackpotAmountString,
      jackpotAmount: attrs.jackpotAmount
    };
  }
});

 })(window);